import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../layout/Dialog';
import Button from '../form/Button';

const ImagePreview = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [src, setSrc] = useState();

  const toggleModal = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (props.src instanceof File) {
      setSrc(URL.createObjectURL(props.src));
    } else {
      setSrc(`${process.env.REACT_APP_FILES_URL}/${props.src}`);
    }
  }, [props.src]);

  return (
    <div
      style={{
        display: 'inline-block',
      }}
    >
      {props.renderType === 'button' && (
        <Button
          tooltip="Image Preview"
          onClick={toggleModal}
          icon="picture"
          size={props.size}
          disabled={props.disabled}
        />
      )}
      {props.renderType === 'image' && (
        <img
          src={src}
          style={{
            height: 'auto',
            width: { md: 180, sm: 80 }[props.size],
            cursor: 'pointer',
          }}
          onClick={toggleModal}
          alt=""
        />
      )}
      <Dialog
        isOpen={isOpen}
        onCancel={() => setIsOpen(false)}
        title="Image Preview"
        width={720}
        actions={[<Button key="closeButton" icon="close-circle" label="Close" onClick={toggleModal} />]}
      >
        <div style={{ backgroundColor: '#dedede', height: '100%', width: '100%' }}>
          <img
            src={src}
            alt=""
            style={{ border: '1px solid #aeaeae', width: '100%', height: 'auto', objectFit: 'contain' }}
          />
        </div>
      </Dialog>
    </div>
  );
};

ImagePreview.propTypes = {
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(File)]).isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
  renderType: PropTypes.oneOf(['button', 'image']),
  disabled: PropTypes.bool,
};

ImagePreview.defaultProps = {
  renderType: 'button',
  size: 'md',
};

export default ImagePreview;
